import { render, staticRenderFns } from "./CloseAttach.vue?vue&type=template&id=3f23164e&"
import script from "./CloseAttach.vue?vue&type=script&lang=js&"
export * from "./CloseAttach.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports